
import { computed, defineComponent, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useDebouncedRef } from '@/lib/hooks/useDebouncedRef';
import { useCouponStore } from '@/store/useCoupon';
import { table } from '@/store/stateless/tables';

export default defineComponent({
  setup() {
    const coupon = useCouponStore();
    const { data, loading, page, pageSize, searchQuery, totalPages } = storeToRefs(coupon);

    const pageModel = computed({
      get: () => page.value,
      set: (v: number) => { page.value = v; },
    });

    onMounted(async () => coupon.searchCoupons());

    useDebouncedRef(() => (page.value = 1), [searchQuery]);
    useDebouncedRef(async () => {
      await coupon.searchCoupons();
      window.scrollTo(0, 0);
    }, [page, pageSize, searchQuery]);

    return {
      data,
      loading,
      pageModel,
      searchQuery,
      table,
      totalPages,
      setSelectedCoupon: coupon.setSelectedCoupon,
    };
  },
});
